/* eslint-disable react-hooks/exhaustive-deps */
import React, { useCallback, useEffect, useRef, useState } from 'react';
import {
  Button,
  Menu,
  MenuItem,
  FormControlLabel,
  Checkbox,
  TextField,
  InputAdornment,
  IconButton,
  Box,
  Typography,
} from '@mui/material';
import {
  BarChart as LayoutGrid,
  ShowChart as LineChart,
  Refresh as RefreshCcwIcon,
  Search,
  Close as X,
  ArrowRight,
  ArrowDropDown,
} from '@mui/icons-material';

import globalFilterList from '../../../../../global-filter.json';
import styles from './dashboard-navigation.module.css';
import { useSamarthDashboardContext } from 'utils/samarth-dashboard-context/hooks/useSamarthDashboardContext';
import { useKpiData } from 'utils/samarth-dashboard-context/hooks/useKpiData';
function buildFactoryMap(staticMap = [], selected = []) {
  const selectedMap = new Set(selected);
  return Object.keys(staticMap).filter((key) => {
    return staticMap[key].filter((id) => selectedMap.has(id)).length
  })
}

export default function DashboardNavigation() {
  const { state ,
  resetGlobalFilters,
  setNewGlobalFilters,
  fetchGlobalFilters, setGlobalViewMode, refreshAllKpiData
} = useSamarthDashboardContext();
  const viewMode = state.viewMode.globalViewMode;
  const { filters } = useKpiData();
const [selectedOptions, setSelectedOptions] = useState({});

  const [basePackDisplayCount, setBasePackDisplayCount] = useState(40);
  const [searchTerms, setSearchTerms] = useState({});
  const loading = state.dashboardData.isLoading.all;
  const globalLoading = state.dashboardData.isLoading.globalFilter;
  const globalFilterData = state.dashboardData.globalFilterData;

  const globalFilter = Object.keys(globalFilterData).length
    ? globalFilterData
    : globalFilterList.filters;

  useEffect(() => {
    setSelectedOptions(() => ({
    ...filters.globalFilters,
    ...(filters.globalFilters?.Factory && {
      values_mapping: filters.globalFilters.Factory,
      Factory : buildFactoryMap(globalFilter.static_filters?.Factory?.values_mapping ?? [] , filters.globalFilters.Factory)
    }),
  }));
  }, [filters.globalFilters?.Factory]); 

  const navItems = [
    {
      label: 'BG',
      hasDropdown: true,
      itemKey: 'BG',
      parentKey: 'simple_filters',
    },
    {
      label: 'SmallC',
      hasDropdown: true,
      itemKey: 'SmallC',
      parentKey: 'simple_filters',
    },
    {
      label: 'Format',
      hasDropdown: true,
      dpMenu: ['SubFormat'],
      itemKey: 'Format',
      parentKey: 'nested_filters',
    },
    {
      label: 'Factory',
      hasDropdown: true,
      itemKey: 'Factory',
      dpMenu: ['values_mapping'],
      parentKey: 'static_filters',
    },
    {
      label: 'Depot',
      hasDropdown: true,
      itemKey: 'Depot',
      parentKey: 'static_filters',
    },
    {
      label: 'Base Pack',
      hasDropdown: true,
      itemKey: 'Basepack',
      parentKey: 'nested_filters',
      dpMenu: ['FG_NUMBER'],
    },
    {
      label: 'Brand',
      hasDropdown: true,
      itemKey: 'BRAND',
      parentKey: 'simple_filters',
    },
    {
      label: 'Segmentation',
      hasDropdown: true,
      itemKey: 'HUL_Level_Segmentation',
      parentKey: 'simple_filters',
    },
    {
      label: 'ABCD',
      hasDropdown: true,
      itemKey: 'ABCD',
      parentKey: 'simple_filters',
    },
  ];

  const dispatchTimeoutRef = useRef(null);
  const latestOptionsRef = useRef(selectedOptions);
  const [openDropdowns, setOpenDropdowns] = useState({});
  const [anchorEls, setAnchorEls] = useState({});
  const [subMenuAnchorEls, setSubMenuAnchorEls] = useState({});
  const [openSubMenus, setOpenSubMenus] = useState({});

  useEffect(() => {
    latestOptionsRef.current = selectedOptions;
  }, [selectedOptions]);

  const closeDropdown = (filterKey) => {
    setOpenDropdowns((prev) => ({ ...prev, [filterKey]: false }));
    setAnchorEls((prev) => ({ ...prev, [filterKey]: null }));
  };

  const handleDropdownOpen = (event, filterKey) => {
    setAnchorEls((prev) => ({ ...prev, [filterKey]: event.currentTarget }));
    setOpenDropdowns((prev) => ({ ...prev, [filterKey]: true }));
  };

  const handleDropdownClose = (filterKey) => {
    setOpenDropdowns((prev) => ({ ...prev, [filterKey]: false }));
    setAnchorEls((prev) => ({ ...prev, [filterKey]: null }));
  };

  const handleSubMenuOpen = (event, key) => {
    setSubMenuAnchorEls((prev) => ({ ...prev, [key]: event.currentTarget }));
    setOpenSubMenus((prev) => ({ ...prev, [key]: true }));
  };

  const handleSubMenuClose = (key) => {
    setOpenSubMenus((prev) => ({ ...prev, [key]: false }));
    setSubMenuAnchorEls((prev) => ({ ...prev, [key]: null }));
  };

  const toggleOption = useCallback(
    (
      filterKey,
      value,
      subMenuKey,
      arrayValue,
      isfromChild = false,
      parentKey = ""
    ) => {
      const current = selectedOptions[filterKey] || [];
      const updated = current.includes(value)
        ? current.filter((v) => v !== value)
        : [...current, value];

      if (subMenuKey && arrayValue && !isfromChild) {
        if (current.includes(value)) {
          setSelectedOptions((prev) => {
            const newState = { ...prev };
            const currentSet = prev[subMenuKey];
            const valuesToRemove = new Set(arrayValue);
            const filtered = currentSet.filter(
              (item) => !valuesToRemove.has(item),
            );
            if (filtered.length > 0) {
              newState[subMenuKey] = filtered;
            } else {
              delete newState[subMenuKey];
            }
            latestOptionsRef.current = newState;
            return newState;
          });
        } else {
          setSelectedOptions((prev) => {
            const newState = {
              ...prev,
              [subMenuKey]: prev[subMenuKey]
                ? [...arrayValue, ...prev[subMenuKey]]
                : [...arrayValue],
            };
            latestOptionsRef.current = newState;
            return newState;
          });
        }
      }

      if(isfromChild && subMenuKey && arrayValue) {
        const parentArr = selectedOptions[subMenuKey];
        const valueIncluded = updated?.includes(value);
        const isParentPresent = parentArr?.includes(parentKey);
        const valuedToExist = new Set(arrayValue);
          
        if(!valueIncluded && isParentPresent){
          const filtered = updated?.filter(
                (item) => valuedToExist.has(item),
          );
          if(!filtered.length){
            setSelectedOptions((prev) => {
              const newState = { ...prev };
              newState[subMenuKey] = prev[subMenuKey]?.filter((item) => item !== parentKey);
              latestOptionsRef.current = newState;
              return newState;
            });
          }
        }else if(valueIncluded && !isParentPresent){
           setSelectedOptions((prev) => {
                const newState = { ...prev, [subMenuKey]: prev[subMenuKey] ? [...prev[subMenuKey], parentKey ] : [parentKey] };
                latestOptionsRef.current = newState;
                return newState;
              });
        }
      }

      setSelectedOptions((prev) => {
        const newState = { ...prev, [filterKey]: updated };
        latestOptionsRef.current = newState;
        return newState;
      });

      if (dispatchTimeoutRef.current) {
        clearTimeout(dispatchTimeoutRef.current);
      }

      dispatchTimeoutRef.current = setTimeout(() => {
        setNewGlobalFilters(latestOptionsRef.current);
        closeDropdown(filterKey);
        fetchGlobalFilters(latestOptionsRef.current).then(() => {
          refreshAllKpiData();
        });
        dispatchTimeoutRef.current = null;
      }, 1500);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [selectedOptions],
  );

  const resetDropdownFilter = useCallback(
    (filterKey) => {
      setSelectedOptions((prev) => {
        const newState = { ...prev };
        delete newState[filterKey];
        latestOptionsRef.current = newState;
        return newState;
      });

      if (dispatchTimeoutRef.current) {
        clearTimeout(dispatchTimeoutRef.current);
      }

      dispatchTimeoutRef.current = setTimeout(() => {
        setNewGlobalFilters(latestOptionsRef.current);
        dispatchTimeoutRef.current = null;
      }, 1500);
    },
    [],
  );

  const resetSubDropdownFilter = useCallback(
    (subFilterKey, parentKey, parentValue) => {
      setSelectedOptions((prev) => {
        const newState = { ...prev };
        delete newState[subFilterKey];
        if(parentKey && parentValue)
          newState[parentKey] = prev[parentKey]?.filter((item) => item !== parentValue);
        latestOptionsRef.current = newState;
        return newState;
      });

      if (dispatchTimeoutRef.current) {
        clearTimeout(dispatchTimeoutRef.current);
      }

      dispatchTimeoutRef.current = setTimeout(() => {
        setNewGlobalFilters(latestOptionsRef.current);
        dispatchTimeoutRef.current = null;
      }, 1500);
    },
    [],
  );

  useEffect(() => {
    return () => {
      if (dispatchTimeoutRef.current) {
        clearTimeout(dispatchTimeoutRef.current);
      }
    };
  }, []);

  const filterOptions = (options, searchTerm) => {
    if (!searchTerm) return options;
    return options.filter((opt) =>
      opt?.toLowerCase().includes(searchTerm.toLowerCase()),
    );
  };

  const filterSubOptions = useCallback(
    (subOptions, searchTerm) => {
      if (!searchTerm) return subOptions;
      if (!subOptions) return [];
      return subOptions.filter((opt) =>
        opt?.toLowerCase().includes(searchTerm.toLowerCase()),
      );
    },
    [],
  );

  const handleSearchChange = (filterKey, value) => {
    setSearchTerms((prev) => ({ ...prev, [filterKey]: value }));
  };

  const hasGlobalFilters =
    filters.globalFilters && Object.keys(filters.globalFilters).length > 0;

  const resetAllFilters = () => {
    setSelectedOptions({});
    setSearchTerms({});
    resetGlobalFilters();
    fetchGlobalFilters([]).then(() => {
          refreshAllKpiData();
    });
    setBasePackDisplayCount(40);
    if (dispatchTimeoutRef.current) {
      clearTimeout(dispatchTimeoutRef.current);
    }
  };

  const renderMenuItem = (item, index) => {
    const filterKey = item.itemKey || item.label;
    const isActive =
      (selectedOptions[filterKey]?.length || 0) > 0 ||
      (item.dpMenu && selectedOptions[item.dpMenu[0]]);
    const options = item.dpMenu
      ? globalFilter[item.parentKey][filterKey]['parent_options'] || globalFilter[item.parentKey][filterKey]['options']
      : globalFilter[item.parentKey][filterKey]?.['options'];


    const dpMenuOptions = filterKey === "Factory" ? globalFilter[item.parentKey][filterKey]?.['values_mapping'] :
      globalFilter[item.parentKey][filterKey]?.[
        Object.keys(globalFilterData || {}).length
          ? 'nested_structure'
          : 'options'
      ];
    const searchTerm = searchTerms[filterKey] || '';
    const filteredOptions = filterOptions(options || [], searchTerm);

    return (
      <div key={index} className={styles.navItem}>
        <Button
          variant={isActive ? "contained" : "text"}
          color={isActive ? "primary" : "inherit"}
          disabled={loading || globalLoading}
          onClick={(e) => handleDropdownOpen(e, filterKey)}
          endIcon={<ArrowDropDown />}
          className={`${styles.navButton} ${isActive ? styles.activeButton : styles.inactiveButton}`}
          sx={{
            color: isActive ? 'white' : '#9ca3af',
            backgroundColor: isActive ? '#2563eb' : 'transparent',
            '&:hover': {
              color: 'white',
              backgroundColor: isActive ? '#1d4ed8' : 'rgba(255, 255, 255, 0.1)',
            },
            '&:disabled': {
              opacity: 0.75,
              color: "white",
              cursor: "not-allowed",
            },
          }}
        >
          {item.label}
        </Button>
        
        <Menu
          anchorEl={anchorEls[filterKey]}
          open={openDropdowns[filterKey] || false}
          onClose={() => handleDropdownClose(filterKey)}
          PaperProps={{
            className: styles.dropdownMenu,
            sx: {
              maxHeight: 400,
              width: 256,
              '& .MuiList-root': {
                padding: '0px',
                paddingTop: '8px',
              },
            },
            onScroll: (e) => {
              if (
                e.currentTarget.scrollTop +
                  e.currentTarget.clientHeight >=
                  e.currentTarget.scrollHeight - 10 &&
                basePackDisplayCount < filteredOptions.length
              ) {
                setBasePackDisplayCount((prev) => prev + 40);
              }
            },
          }}
        >
          <Box className={styles.searchContainer}>
            <TextField
              size="small"
              placeholder="Search"
              value={searchTerm}
              onChange={(e) => handleSearchChange(filterKey, e.target.value)}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <Search sx={{ fontSize: 16 }} />
                  </InputAdornment>
                ),
              }}
              sx={{
                flex: 1,
                '& .MuiInputBase-root': {
                  height: 32,
                  fontSize: '12px',
                },
              }}
              onClick={(e) => e.stopPropagation()}
            />
            {isActive && (
              <Button
                variant="outlined"
                size="small"
                onClick={(e) => {
                  e.stopPropagation();
                  resetDropdownFilter(filterKey);
                  if (item.dpMenu)
                    resetSubDropdownFilter(item.dpMenu[0]);
                }}
                sx={{
                  minWidth: 32,
                  height: 32,
                  padding: '4px',
                  borderColor: '#d1d5db',
                  backgroundColor: '#e5e7eb',
                  '&:hover': {
                    backgroundColor: '#f3f4f6',
                  },
                }}
              >
                <X sx={{ fontSize: 16 }} />
              </Button>
            )}
          </Box>

          {filteredOptions
            .slice(0, basePackDisplayCount)
            .map((opt, optIndex) => {
              if (Array.isArray(item.dpMenu)) {
                const subMenuKey = `${filterKey}-${opt}`;
                return (
                  <Box key={optIndex} className={styles.menuItemContainer}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={selectedOptions[filterKey]?.includes(opt) || false}
                          onChange={() => {
                            toggleOption(
                              filterKey,
                              opt,
                              item.dpMenu?.[0],
                              dpMenuOptions?.[opt],
                            );
                          }}
                          size="small"
                        />
                      }
                      label={opt}
                      sx={{ flex: 1, margin: 0 }}
                    />
                    <IconButton
                      size="small"
                      onClick={(e) => handleSubMenuOpen(e, subMenuKey)}
                      sx={{ padding: '4px' }}
                    >
                      <ArrowRight />
                    </IconButton>

                    <Menu
                      anchorEl={subMenuAnchorEls[subMenuKey]}
                      open={openSubMenus[subMenuKey] || false}
                      onClose={() => handleSubMenuClose(subMenuKey)}
                      anchorOrigin={{
                        vertical: 'top',
                        horizontal: 'right',
                      }}
                      transformOrigin={{
                        vertical: 'top',
                        horizontal: 'left',
                      }}
                      PaperProps={{
                        sx: {
                          minWidth: 200,
                          maxHeight: 400,
                          '& .MuiList-root': {
                            padding: '8px',
                          },
                        },
                      }}
                    >
                      <Box className={styles.searchContainer}>
                        <TextField
                          size="small"
                          placeholder="Search..."
                          value={searchTerms[item.dpMenu?.[0] || ''] || ''}
                          onChange={(e) =>
                            handleSearchChange(
                              item.dpMenu?.[0] || '',
                              e.target.value,
                            )
                          }
                          InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">
                                <Search sx={{ fontSize: 16 }} />
                              </InputAdornment>
                            ),
                          }}
                          sx={{
                            flex: 1,
                            '& .MuiInputBase-root': {
                              height: 32,
                              fontSize: '12px',
                            },
                          }}
                          onClick={(e) => e.stopPropagation()}
                        />
                        {(selectedOptions[item.dpMenu?.[0] || '']?.length || 0) > 0 && (
                          <Button
                            variant="outlined"
                            size="small"
                            onClick={(e) => {
                              e.stopPropagation();
                              resetSubDropdownFilter(
                                item.dpMenu?.[0] || '',
                                filterKey,
                                opt,
                              );
                            }}
                            sx={{
                              minWidth: 32,
                              height: 32,
                              padding: '4px',
                              borderColor: '#d1d5db',
                              backgroundColor: '#e5e7eb',
                              '&:hover': {
                                backgroundColor: '#f3f4f6',
                              },
                            }}
                          >
                            <X sx={{ fontSize: 16 }} />
                          </Button>
                        )}
                      </Box>

                      {filterSubOptions(
                        dpMenuOptions?.[opt],
                        searchTerms[item.dpMenu?.[0] || ''] || '',
                      )?.map((child, childIndex) => (
                        <MenuItem key={childIndex} sx={{ padding: '4px 8px' }}>
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={
                                  selectedOptions[
                                    item.dpMenu ? item.dpMenu[0] : ''
                                  ]?.includes(child) || false
                                }
                                onChange={() =>
                                  toggleOption(
                                    item.dpMenu ? item.dpMenu[0] : '',
                                    child,
                                    filterKey,
                                    dpMenuOptions?.[opt],
                                    true,
                                    opt
                                  )
                                }
                                size="small"
                              />
                            }
                            label={child}
                            sx={{ margin: 0 }}
                          />
                        </MenuItem>
                      ))}
                    </Menu>
                  </Box>
                );
              } else {
                return (
                  <MenuItem key={optIndex} sx={{ padding: '4px 8px' }}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={selectedOptions[filterKey]?.includes(opt) || false}
                          onChange={() => toggleOption(filterKey, opt)}
                          size="small"
                        />
                      }
                      label={opt}
                      sx={{ margin: 0 }}
                    />
                  </MenuItem>
                );
              }
            })}

          {filteredOptions.length === 0 && searchTerm && (
            <Box className={styles.noResults}>
              <Typography variant="body2" color="text.secondary">
                No results found for "{searchTerm}"
              </Typography>
            </Box>
          )}
        </Menu>
      </div>
    );
  };

  return (
    <Box className={styles.container}>
      <Box className={styles.navContainer}>
        {navItems.map(renderMenuItem)}

        {hasGlobalFilters && (
          <Button
            variant="outlined"
            size="small"
            onClick={resetAllFilters}
            disabled={loading}
            sx={{
              color: 'white',
              borderColor: 'white',
              backgroundColor: 'rgba(0, 0, 0, 0.1)',
              marginLeft: 2,
              '&:hover': {
                backgroundColor: '#1e3a8a',
              },
            }}
          >
            <RefreshCcwIcon sx={{ fontSize: 16 }} />
          </Button>
        )}
      </Box>

      <Box className={styles.viewModeContainer}>
        <Button
          variant="text"
          onClick={() => setGlobalViewMode('graph')}
          startIcon={<LineChart />}
          sx={{
            color: viewMode === 'graph' ? 'white' : '#9ca3af',
            '&:hover': {
              backgroundColor: 'rgba(255, 255, 255, 0.1)',
            },
          }}
        >
          Graph View
        </Button>
        <Button
          variant="text"
          onClick={() => setGlobalViewMode('table')}
          startIcon={<LayoutGrid />}
          sx={{
            color: viewMode === 'table' ? 'white' : '#9ca3af',
            '&:hover': {
              backgroundColor: 'rgba(255, 255, 255, 0.1)',
            },
          }}
        >
          Table View
        </Button>
      </Box>
    </Box>
  );
}